/**
 * Critério alinhado ao endpoint /sugestoes-meias:
 * grupo_produto === "MEIA" OU subgrupo_produto === "MEIA".
 * Fallback por descrição quando o item do carrinho ainda não carrega taxonomia.
 */
export const isProdutoMeia = (produto) => {
    if (!produto) return false;

    const grupo = String(produto.grupo_produto || "").trim().toUpperCase();
    const subgrupo = String(produto.subgrupo_produto || "").trim().toUpperCase();
    if (grupo === "MEIA" || subgrupo === "MEIA") return true;

    if (grupo || subgrupo) return false;

    const descricao = String(produto.use_descricao || produto.name || "").toUpperCase();
    return /(^|\s)MEIA(\s|$)/.test(descricao);
};

export const carrinhoTemMeia = (cartItems) => {
    if (!Array.isArray(cartItems) || cartItems.length === 0) return false;
    return cartItems.some(isProdutoMeia);
};
